import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { SegmentsService } from '@core/services/segments.service';
import { Segment } from '@shared/interfaces/segment';

@Component({
  selector: 'app-segments-edit',
  templateUrl: './segments-edit.component.html'
})
export class SegmentsEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public segment: Segment;
  public segmentsList: Array<Segment> = [];
  public segmentForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private segmentsService: SegmentsService,
    public dialogRef: MatDialogRef<SegmentsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    this.constants.title = this.appConfig.LANG.segments.title;

    this.segmentForm = new FormGroup({
      id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required)
    });

    this.constants.action = this.data.action;

    if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
      this.constants.title =
        this.appConfig.LANG.title.edit + ' ' + this.constants.title;
      this.segment = this.data.item;
      this.segmentForm.patchValue({
        id: this.segment.id,
        name: this.segment.name
      });
    } else if (this.constants.action === this.appConfig.ACTIONS.add.id) {
      this.constants.title =
        this.appConfig.LANG.title.add + ' ' + this.constants.title;
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.segmentForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.segmentsService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
